import React from "react";
import TimestampInput from "../../input/timestamp-input";

const DateTime1Widget = ({ widget, onValueUpdate }) => {
  const handleValueUpdate = (data) => {
    console.debug(data);
    const updatedWidget = { ...widget, value: data };
    onValueUpdate(updatedWidget);
  };

  return (
    <div className="flex items-stretch h-full w-full">
      {widget && (
        <TimestampInput valueSpec={widget} onChange={handleValueUpdate} />
      )}
    </div>
  );
};

export default DateTime1Widget;
